import { render, staticRenderFns } from "./FormMensageria.vue?vue&type=template&id=5deb4ba8&scoped=true"
import script from "./FormMensageria.vue?vue&type=script&lang=js"
export * from "./FormMensageria.vue?vue&type=script&lang=js"
import style0 from "./FormMensageria.vue?vue&type=style&index=0&id=5deb4ba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5deb4ba8",
  null
  
)

export default component.exports